<template lang="pug">
  b-modal#updatePTSB(
    ref="updatePTSB"
    :title="$t('ui.combine.update_position_taking')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="xl"
    @ok="done"
    @show="reset"
    @shown="shown"
    :hide-footer="!$helpers.getVisible(editLimit)"
  )
    b-form(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      span #[b {{ $t("ui.account_id") + " : " + accountId.toUpperCase() }}]
      #tblModal.table-sm.table-responsive
        table.table.table-bordered(v-if="$store.getters.getPTSB")
          thead
            tr
              th.align-middle.width-100 {{ $t("ui.sport_types") }}
              th.align-middle.width-150 {{ $t("ui.types") }}
              th.text-center(style="width:15%;")
                small.text-warning {{ $t("ui.copy_to_bottom") }}
                b-form-checkbox(
                  size="sm"
                  v-model="copyAllUpline"
                  :title="$helpers.copyAllUpline_title()"
                  @input="toggleAll"
                  plain
                  :disabled="!$helpers.getVisible(editLimit)"
                ) {{ $helpers.getUplineName($store.getters.accountType) }}
              th.text-center(style="width:15%;" v-show="!$helpers.isAgentLevel()")
                small.text-warning {{ $t("ui.copy_to_bottom") }}
                b-form-checkbox(
                  size="sm"
                  v-model="copyAllAccount"
                  :title="$helpers.copyAllAccount_title()"
                  @input="toggleAll"
                  plain
                  :disabled="!$helpers.getVisible(editLimit)"
                ) {{ $helpers.getUplineName($store.getters.accountType - 1) }}
              th.text-center(style="width:15%;" v-show="!$helpers.isAgentLevel()")
                small.text-warning {{ $t("ui.copy_to_bottom") }}
                b-form-checkbox(
                  size="sm"
                  v-model="copyAllRemaining"
                  :title="$helpers.copyAllRemaining_title()"
                  @input="toggleAll"
                  plain
                  :disabled="!$helpers.getVisible(editLimit)"
                ) {{ $t("ui.remaining") }}
              th.text-center(style="width:15%;" v-show="!$helpers.isAgentLevel()")
                small.text-warning {{ $t("ui.copy_to_bottom") }}
                b-form-checkbox(
                  size="sm"
                  v-model="copyAllMin"
                  :title="$helpers.copyAllMin_title()"
                  @input="toggleAll"
                  plain
                  :disabled="!$helpers.getVisible(editLimit)"
                ) {{ $t("ui.min") }}
          ptTableRowSoccer(ref="ptTableRowSoccer" :loading="!$helpers.getVisible(editLimit)" @clicked="toggleAll" isEdit=true)
          ptTableRowParlay(ref="ptTableRowParlay" :loading="!$helpers.getVisible(editLimit)" isEdit=true)
      .form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import ptTableRowSoccer from "@/components/positionTaking/ptTableRowSoccer.vue";
import ptTableRowParlay from "@/components/positionTaking/ptTableRowParlay.vue";
import SubmitButton from "@/library/SubmitButton";
import PTSelect from "@/library/PTSelect";

export default {
  components: {
    ptTableRowSoccer,
    ptTableRowParlay,
    PTSelect,
    SubmitButton
  },
  props: {
    accountId: ""
  },
  data() {
    return {
      loading: false,
      copyAllUpline: false,
      copyAllAccount: false,
      copyAllRemaining: false,
      copyAllMin: false,
      ptJSON: {
        soccer_hdp_upline_pt: 0,
        soccer_hdp_account_pt: 0,
        soccer_hdp_upline_remaining: 0,
        soccer_hdp_account_min: 0,
        soccer_1x2_upline_pt: 0,
        soccer_1x2_account_pt: 0,
        soccer_1x2_upline_remaining: 0,
        soccer_1x2_account_min: 0,
        soccer_others_upline_pt: 0,
        soccer_others_account_pt: 0,
        soccer_others_upline_remaining: 0,
        soccer_others_account_min: 0,
        parlay_upline_pt: 0,
        parlay_account_pt: 0,
        parlay_upline_remaining: 0,
        parlay_account_min: 0
      },
      submission: {
        success: true,
        status: ""
      }
    }
  },
  validations: {},
  computed: {
    editLimit() {
      return [config.accessRoles.editLimit]
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault()
      this.submit()
    },
    setUpline(mode, fromSoccer, lottery) {
      let maxPT = 0
      if(['1X2','OTH','PL'].includes(mode)) {
        switch(mode) {
          case "1X2":
            maxPT = this.$refs.ptTableRowSoccer.soccer_1x2_upline_max
            if (fromSoccer > maxPT) {
              return maxPT
            }
            break
          case "OTH":
            maxPT = this.$refs.ptTableRowSoccer.soccer_others_upline_max
            if (fromSoccer > maxPT) {
              return maxPT
            }
            break
          case "PL":
            maxPT = this.$refs.ptTableRowParlay.parlay_upline_max
            if (fromSoccer > maxPT) {
              return maxPT
            }
            break
        }
        return fromSoccer
      } else {
        return 0
      }
    },
    setAccount(mode, fromSoccer, lottery) {
      let maxPT = 0
      let currentPT = 0
      let balance = 0

      if(['1X2','OTH','PL'].includes(mode)) {
        switch(mode) {
          case "1X2":
            maxPT = this.$refs.ptTableRowSoccer.soccer_1x2_upline_max
            currentPT = this.$refs.ptTableRowSoccer.soccer_1x2_upline_pt
            balance = maxPT - currentPT
            if (fromSoccer > balance) {
              return balance
            }
            break
          case "OTH":
            maxPT = this.$refs.ptTableRowSoccer.soccer_others_upline_max
            currentPT = this.$refs.ptTableRowSoccer.soccer_others_upline_pt
            balance = maxPT - currentPT
            if (fromSoccer > balance) {
              return balance
            }
            break
          case "PL":
            maxPT = this.$refs.ptTableRowParlay.parlay_upline_max
            currentPT = this.$refs.ptTableRowParlay.parlay_upline_pt
            balance = maxPT - currentPT
            if (fromSoccer > balance) {
              return balance
            }
            break
        }
        return fromSoccer
      } else {
        return 0
      }
    },
    setRemaining(mode, fromSoccer, lottery) {
      let maxPT = 0
      if(['1X2','OTH','PL'].includes(mode)) {
        switch(mode) {
          case "1X2":
            maxPT = this.$refs.ptTableRowSoccer.soccer_1x2_account_pt
            if (fromSoccer > maxPT) {
              return maxPT
            }
            break
          case "OTH":
            maxPT = this.$refs.ptTableRowSoccer.soccer_others_account_pt
            if (fromSoccer > maxPT) {
              return maxPT
            }
            break
          case "PL":
            maxPT = this.$refs.ptTableRowParlay.parlay_account_pt
            if (fromSoccer > maxPT) {
              return maxPT
            }
            break
        }
        return fromSoccer
      } else {
        return 0
      }
    },
    upline() {
      let soccerHDP = this.$refs.ptTableRowSoccer.soccer_hdp_upline_pt
      this.$refs.ptTableRowSoccer.soccer_1x2_upline_pt = this.setUpline('1X2', soccerHDP)
      this.$refs.ptTableRowSoccer.soccer_others_upline_pt = this.setUpline('OTH', soccerHDP)
      this.$refs.ptTableRowParlay.parlay_upline_pt = this.setUpline('PL', soccerHDP)
    },
    account() {
      let soccerHDP = this.$refs.ptTableRowSoccer.soccer_hdp_account_pt
      this.$refs.ptTableRowSoccer.soccer_1x2_account_pt = this.setAccount('1X2', soccerHDP)
      this.$refs.ptTableRowSoccer.soccer_others_account_pt = this.setAccount('OTH', soccerHDP)
      this.$refs.ptTableRowParlay.parlay_account_pt = this.setAccount('PL', soccerHDP)
    },
    remaining() {
      let soccerHDP = this.$refs.ptTableRowSoccer.soccer_hdp_upline_remaining
      this.$refs.ptTableRowSoccer.soccer_1x2_upline_remaining = this.setRemaining('1X2', soccerHDP)
      this.$refs.ptTableRowSoccer.soccer_others_upline_remaining = this.setRemaining('OTH', soccerHDP)
      this.$refs.ptTableRowParlay.parlay_upline_remaining = this.setRemaining('PL', soccerHDP)
    },
    min() {
      let soccerHDP = this.$refs.ptTableRowSoccer.soccer_hdp_account_min
      this.$refs.ptTableRowSoccer.soccer_1x2_account_min = this.setRemaining('1X2', soccerHDP)
      this.$refs.ptTableRowSoccer.soccer_others_account_min = this.setRemaining('OTH', soccerHDP)
      this.$refs.ptTableRowParlay.parlay_account_min = this.setRemaining('PL', soccerHDP)
    },
    toggleAll: function() {
      if(this.copyAllUpline) {
        this.upline()
      }

      if(this.copyAllAccount) {
        this.account()
      }

      if(this.copyAllRemaining) {
        // if(this.copyAllAccount) {
          this.remaining()
        // }
      }

      if(this.copyAllMin) {
        // if(this.copyAllAccount) {
          this.min()
        // }
      }
    },
    isValidForm() {
      this.$refs.ptTableRowSoccer.$v.$touch()
      this.$refs.ptTableRowParlay.$v.$touch()

      return this.$refs.ptTableRowSoccer.$v.$invalid ||
        this.$refs.ptTableRowParlay.$v.$invalid
    },
    formPtJson: function() {
      let allRefs = this.$refs
      for (var refType in allRefs) {
        let refList = this.$refs[refType].$refs
        for(var ref in refList) {
          this.ptJSON[ref] = this.$refs[refType][ref]
        }
      }
    },
    getChildPositionTaking: function() {
      $("select").prop("disabled", !this.$helpers.getVisible(this.editLimit))
      let account_id = this.accountId
      let platform_code = "SPORTSBOOK"
      if(account_id) {
        this.$store
        .dispatch("user/getChildPositionTaking", { account_id, platform_code })
        .then(response => {
          console.log("data", response.data.pt)
          let data = response.data.pt
          this.$refs.ptTableRowSoccer.$v.soccer_hdp_upline_pt.$model = this.$helpers.getPTSB(data, 'HDP', 'SOCCER', 'upline_pt')
          this.$refs.ptTableRowSoccer.$v.soccer_hdp_account_pt.$model = this.$helpers.isAgentLevel() ? 0 : this.$helpers.getPTSB(data, 'HDP', 'SOCCER', 'account_pt')
          this.$refs.ptTableRowSoccer.$v.soccer_hdp_upline_remaining.$model = this.$helpers.isAgentLevel() ? 0 : this.$helpers.getPTSB(data, 'HDP', 'SOCCER', 'upline_remaining')
          this.$refs.ptTableRowSoccer.$v.soccer_hdp_account_min.$model = this.$helpers.isAgentLevel() ? 0 : this.$helpers.getPTSB(data, 'HDP', 'SOCCER', 'account_min')
          this.$refs.ptTableRowSoccer.$v.soccer_1x2_upline_pt.$model = this.$helpers.getPTSB(data, '1X2', 'SOCCER', 'upline_pt')
          this.$refs.ptTableRowSoccer.$v.soccer_1x2_account_pt.$model = this.$helpers.isAgentLevel() ? 0 : this.$helpers.getPTSB(data, '1X2', 'SOCCER', 'account_pt')
          this.$refs.ptTableRowSoccer.$v.soccer_1x2_upline_remaining.$model = this.$helpers.isAgentLevel() ? 0 : this.$helpers.getPTSB(data, '1X2', 'SOCCER', 'upline_remaining')
          this.$refs.ptTableRowSoccer.$v.soccer_1x2_account_min.$model = this.$helpers.isAgentLevel() ? 0 : this.$helpers.getPTSB(data, '1X2', 'SOCCER', 'account_min')
          this.$refs.ptTableRowSoccer.$v.soccer_others_upline_pt.$model = this.$helpers.getPTSB(data, 'OTHERS', 'SOCCER', 'upline_pt')
          this.$refs.ptTableRowSoccer.$v.soccer_others_account_pt.$model = this.$helpers.isAgentLevel() ? 0 : this.$helpers.getPTSB(data, 'OTHERS', 'SOCCER', 'account_pt')
          this.$refs.ptTableRowSoccer.$v.soccer_others_upline_remaining.$model = this.$helpers.isAgentLevel() ? 0 : this.$helpers.getPTSB(data, 'OTHERS', 'SOCCER', 'upline_remaining')
          this.$refs.ptTableRowSoccer.$v.soccer_others_account_min.$model = this.$helpers.isAgentLevel() ? 0 : this.$helpers.getPTSB(data, 'OTHERS', 'SOCCER', 'account_min')

          this.$refs.ptTableRowParlay.$v.parlay_upline_pt.$model = this.$helpers.getPTSB(data, 'PARLAY', 'PARLAY', 'upline_pt')
          this.$refs.ptTableRowParlay.$v.parlay_account_pt.$model = this.$helpers.isAgentLevel() ? 0 : this.$helpers.getPTSB(data, 'PARLAY', 'PARLAY', 'account_pt')
          this.$refs.ptTableRowParlay.$v.parlay_upline_remaining.$model = this.$helpers.isAgentLevel() ? 0 : this.$helpers.getPTSB(data, 'PARLAY', 'PARLAY', 'upline_remaining')
          this.$refs.ptTableRowParlay.$v.parlay_account_min.$model = this.$helpers.isAgentLevel() ? 0 : this.$helpers.getPTSB(data, 'PARLAY', 'PARLAY', 'account_min')
          $("select").prop("disabled", !this.$helpers.getVisible(this.editLimit))
        })
        .catch(response => {
          // console.log("Failed:getChildPositionTaking", response)
        });
      } else {
        this.cancel()
      }
    },
    submit: function() {
      // this.reset()
      if (!this.isValidForm()) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_account_position_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.updatePositionTaking()
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_account_position_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    updatePositionTaking: function() {
      this.formPtJson()
      let account_id = this.accountId
      let pt = this.ptJSON
      this.$store
        .dispatch("user/updatePositionTakingSB1", { account_id, pt })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if(this.submission.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.update_account_position_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          // console.log("Failed:updatePositionTakingSB1", response)
          this.loading = false;
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
      this.copyAllUpline = false
      this.copyAllAccount = false
      this.copyAllRemaining = false
      this.copyAllMin = false
    },
    shown: function() {
      // this.$nextTick(() => {
        this.$v.$reset()
        this.$helpers.getPositionTaking()
        this.getChildPositionTaking()
      // });
    },
    cancel: function() {
      // this.$emit("clicked")
      this.$refs.updatePTSB.hide()
    }
  }
};
</script>

